// A click on a control inside a grid row is that control's, never the row's.
//
// AG Grid raises rowClicked for EVERY click inside a row -- the pinned edit /
// copy / delete buttons, the ⋮ toggle, a switch, a checkbox, a link -- and a
// React stopPropagation can't stop it: AG Grid listens on its own elements,
// below React's root listener, so it has already seen the click. Without this
// rule every row control also opened the row (Alert routing › Routes, owner
// 2026-10-07: edit, copy, delete and ⋮ all opened the route editor).
//
// TableAG applies it to every grid (TableAgClient, TableAgInfinite and
// TableBuilder all hand onRowClicked to TableAG), so a page never needs its
// own guard. Mark anything else that acts on its own with data-no-row-click.
export const OWN_CLICK_SELECTOR = [
  'button',
  'a[href]',
  'input',
  'select',
  'textarea',
  'label',
  'summary',
  '[role="button"]',
  '[role="link"]',
  '[role="menuitem"]',
  '[role="menuitemcheckbox"]',
  '[role="menuitemradio"]',
  '[role="switch"]',
  '[role="checkbox"]',
  '[role="radio"]',
  '[role="tab"]',
  '[role="option"]',
  '.dropdown-menu',
  '.dropdown-toggle',
  // ColumnLink's link-text action (a span that navigates on click).
  '.edxr-link-action',
  '[data-no-row-click]'
].join(',')

// True when the click (AG Grid's rowClicked `event`) landed on, or inside, a
// control that sits inside the row. A control AROUND the grid (a grid inside a
// label, say) doesn't count: only what is in the row is the row's control.
export const isOwnClick = event => {
  const target = event && event.target
  if (!target || typeof target.closest !== 'function') return false
  const control = target.closest(OWN_CLICK_SELECTOR)
  if (!control) return false
  const row = target.closest('.ag-row')
  return !row || row.contains(control)
}
